import { render, staticRenderFns } from "./AdminExports.vue?vue&type=template&id=4b6053c7"
import script from "./AdminExports.vue?vue&type=script&lang=ts"
export * from "./AdminExports.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports